<template>
  <div>
    <div class="train">
      <div class="flex-center search">
        <van-search class="flex1" v-model="activityName" clearable placeholder="输入训练营名称搜索" @clear="clearPlaybill" @search="updateSearch" />
        <span class="search-text" @click="updateSearch">搜索</span>
      </div>
      <div class="subject-list" id="search">
        <ul ref="typeTextRef" class="flex-center">
          <li v-for="(item, i) in optionList" :key="i" @click="chooseClick(item)" :class="activeId == item.id ? 'active-color' : ''">
            {{ item.name }}
          </li>
        </ul>
        <van-dropdown-menu v-if="offsetWidth >= 360" class="search-menu">
          <van-dropdown-item title="" ref="item">
            <div class="search-flex">
              <p v-for="(item, i) in optionList" :key="'option' + i" @click="chooseClick(item)" :class="activeId == item.id ? 'active-color' : ''">
                {{ item.name }}
              </p>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <van-empty v-show="materialImgList.length <= 0" description="暂无数据" />
      <van-list
        v-if="materialImgList.length > 0"
        v-model="loading"
        :finished="finished"
        loading-text="加载中..."
        :finished-text="finishedtext"
        @load="load_more"
        :immediate-check="false"
      >
        <div class="content flex-center-wrap">
          <div v-for="item in materialImgList" :key="item.id" @click="linkDetail(item)">
            <img v-lazy="item.posterUrl" alt="" />
            <p class="van-ellipsis">{{ item.name }}</p>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { getCategoryList, trainPosterList } from "@/server/api.js";

export default {
  data() {
    return {
      activityName: "",
      isCancel: false,
      showOption: true,
      loading: false,
      finished: false,
      switch1: "",
      activeId: "全部",
      pageNum: 0,
      pageSize: 10,
      finishedtext: "没有更多了",
      optionList: [],
      materialImgList: [],
      offsetWidth: 0,
    };
  },
  async mounted() {
    this.posterList();
  },
  methods: {
    posterList() {
      getCategoryList().then((res) => {
        if (res.code == "200") {
          this.optionList = [{ name: "全部", id: "全部" }, ...res.data];
          this.materialList();
          this.offsetWidth = this.$refs.typeTextRef.offsetWidth;
        }
      });
    },
    chooseClick(obj) {
      if (this.activeId == obj.id) return;
      this.materialImgList = [];
      this.activeId = obj.id;
      this.materialList();
    },
    async materialList() {
      this.loading = true;
      const res = await trainPosterList({
        name: this.activityName,
        categoryId: this.activeId == "全部" ? "" : this.activeId,
      });
      this.loading = false;
      if (res.code != "200") {
        Toast.fail(res.msg);
        this.finished = false;
        this.finishedtext = res.msg;
        return;
      }
      this.materialImgList = this.materialImgList.concat(res.data);
      this.finished = true;
    },
    load_more() {
      this.pageNum++;
      this.materialList();
    },
    linkDetail(obj) {
      this.$router.push({ path: "/trainingCampdetail", query: { id: obj.id } });
    },
    updateSearch() {
      this.materialImgList = [];
      this.materialList();
    },
    clearPlaybill() {
      this.materialImgList = [];
      this.activityName = "";
      this.materialList();
    },
  },
};
</script>
<style scoped lang="less">
.train {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  .search {
    padding: 0 28px;
    background: #fff;
  }
  .flex1 {
    padding: 25px 12px 25px 0;
  }
  /deep/.van-search__content {
    height: 80px;
    border-radius: 40px;
    background: #fff;
    border: 1px solid #d8d8d8;
  }
  /deep/.van-field__control {
    font-size: 28px;
    height: 80px;
    margin-top: -10px;
  }
  /deep/.van-field__left-icon {
    line-height: 70px;
    .van-icon-search {
      font-size: 32px;
      color: #999;
      position: relative;
      top: -3px;
    }
  }
  .search-text {
    font-size: 32px;
    color: #333;
  }
  .subject-list {
    padding: 0 28px 28px;
    background: #fff;
    position: relative;
    box-shadow: 0px 3px 8px -3px rgba(0, 0, 0, 0.16);
    ul {
      color: #333;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
      li {
        flex-shrink: 0;
        margin-right: 40px;
        font-size: 28px;
        cursor: pointer;
        &:last-child {
          margin: 0;
        }
      }
      .active-color {
        color: #277fff;
      }
    }
  }
  .content {
    padding: 20px 28px 0;
    justify-content: space-between;
    background: #fff;
    div {
      max-width: 48%;
      img {
        // width: 337px;
        width: 98%;
        height: 600px;
        border-radius: 16px;
        object-fit: cover;
        object-position: top;
      }
      p {
        // width: 337px;
        width: 90%;
        text-align: center;
        font-size: 28px;
        color: #333;
        margin: 12px 0 34px 0;
      }
    }
  }
  .search-menu {
    /deep/.van-dropdown-menu__bar {
      height: auto;
    }
    .search-flex {
      margin-top: 26px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 30px 8px 10px;
      font-size: 24px;
      border-top: solid 1px #f6f6f6;
    }
    p {
      margin-left: 20px;
      margin-bottom: 20px;
      padding: 10px 25px;
      background: #f2f2f2;
      border-radius: 8px;
    }
    .active-color {
      color: #ffffff;
      background: #277fff;
    }
    /deep/.van-dropdown-menu__title {
      width: 40px;
      height: 40px;
      position: absolute;
      right: -1px;
      top: -40px;
      background: #fff;
    }
    /deep/.van-dropdown-menu__title--active {
      color: #999;
    }
    /deep/.van-dropdown-menu__title::after {
      font-size: 40px;
      right: 10px;
      border-width: 8px;
      border-color: transparent transparent #999 #999;
    }
  }
}
</style>
